import {URL_PROVEEDOR} from "@/api/config";

export default {
  namespaced: true,
  state: {
    proveedores: [],
    fetching: false,
    saved: false
  },
  mutations: {
    "FETCH_PROVEEDORES"(state, payload) {
      state.proveedores = payload
    },
    "FETCHING_PROVEEDORES"(state) {
      state.fetching = true
    },
    "FETCHED_PROVEEDORES"(state) {
      state.fetching = false
    },
    "TOGGLE_SAVED"(state) {
      state.saved = !state.saved
    }
  },
  actions: {
    async getProveedores({commit}) {
      commit("FETCHING_PROVEEDORES")
      const { data } = await this._vm.$axios.get(URL_PROVEEDOR + "?ordenar_por=nombre&orden=asc");
      commit("FETCH_PROVEEDORES", data.items)
      commit("FETCHED_PROVEEDORES")
    },
    async updateProveedor({commit}, {proveedor, costo, producto_id}) {
      commit("TOGGLE_SAVED")
      await this._vm.$axios.patch(`http://localhost:8001/api/marketing/producto/${producto_id}/proveedor`,{
        nombreProveedor: proveedor,
        costo
      })
      commit("TOGGLE_SAVED")
    }
  },
  getters: {
    proveedores: ({ proveedores }) => proveedores,
    listProveedores: ({ proveedores }) => proveedores.map(p => ({value: p.nombre, label: p.nombre})),
    fetching: ({fetching}) => fetching,
    saved: ({saved}) => saved
  }
}
